module.exports = __webpack_public_path__ + "media/images/soar/loading-gif-f604e9f594be550b759b1a8ab2eab0aa.gif";